import { render, staticRenderFns } from "./UgcDetail.vue?vue&type=template&id=9d4bc3e0&"
import script from "./UgcDetail.vue?vue&type=script&lang=ts&"
export * from "./UgcDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports